import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useState } from "react";
import { functions } from "@poseidon/firebase/firebase";

export const useProcessSettlement = () => {
  const [executeCallable, saving, error] = useHttpsCallable(
    functions,
    "processSettlement"
  );
  const [complete, setComplete] = useState(false);
  const processSettlement = async (agreementId, settlementId) => {
    setComplete(false);
    try {
      await executeCallable({ agreementId, settlementId });
      setComplete(true);
    } catch (err) {
      setComplete(false);
    }
  };
  return {
    saving,
    error,
    success: !saving && !error && complete,
    processSettlement,
  };
};
